import * as React from 'react';
import * as styles from './AboutUs.module.scss';
import PageInfo from "../../../common/PageInfo/PageInfo";
import CarouselItem from '../../../common/Carousel/CarouselItem/CarouselItem';
import { COUNTRIES_COUNT } from "../../../../constants/countries";

const AboutUs = () => (
  <section className={styles.root}>
    <div className={styles.backgroundImage} />
    <div className={styles.containerWrapper}>
      <CarouselItem title1='About'
                    title2='us'
                    subtitle1='Few words'
                    description={`Founded in 2015, Flatfy exists to help people around the world effortlessly find a new place to live. We pull listings from dozens of sources in each of our ${COUNTRIES_COUNT} local markets. We use AI and data science to analyze, categorize and group listings to make home search more convenient.`}
      />
      <PageInfo text={'03 - company'} />
    </div>
  </section>
);

export default AboutUs;
